export const applicationStatuses = [
  'draft',
  'submitted',
  'under_review',
  'rejected',
  'withdrawn',
  'accepted',
  'deleted',
] as const

export const applicationStatusLabels: Record<ApplicationStatus, string> = {
  draft: 'Draft',
  submitted: 'Pending',
  under_review: 'Under review',
  rejected: 'Rejected',
  withdrawn: 'Withdrawn',
  accepted: 'Accepted',
  deleted: 'Deleted',
}

export const applicationStatusColors: Record<
  ApplicationStatus,
  { text: string }
> = {
  draft: { text: 'text-foreground' },
  submitted: { text: 'text-foreground' },
  under_review: { text: 'text-warning-foreground' },
  rejected: { text: 'text-destructive-foreground' },
  withdrawn: { text: 'text-muted-foreground' },
  accepted: { text: 'text-success-foreground' },
  deleted: { text: 'text-destructive-foreground' },
}

type ApplicationStatus = typeof applicationStatuses[number]
export default ApplicationStatus
